import { render, staticRenderFns } from "./productmodel.vue?vue&type=template&id=1c7eda5c&scoped=true&"
import script from "./productmodel.vue?vue&type=script&lang=js&"
export * from "./productmodel.vue?vue&type=script&lang=js&"
import style0 from "./productmodel.vue?vue&type=style&index=0&id=1c7eda5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7eda5c",
  null
  
)

export default component.exports